export { default as Mentors } from "./main";
import routes from "./routes";
import * as Anchors from "./anchors";
export default {
  Anchors,
  routes,
};
